import React from 'react';
import HeroAbout from './HeroAbout';
import AboutDes from './AboutDes'
import Footer from './Footer'
import HeroNavbarWithDrawer from './HeroNavbarWithDrawer'
const About = () => {


  return (
  <div ><HeroNavbarWithDrawer/><HeroAbout/><AboutDes/><Footer/></div> 

  );
};

export default About;
